import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { CmAuthService, HiddenFormPost } from '@ats/cm/core';

@Directive({
    selector: '[cmFileDownload]',
    standalone: false
})
export class CmFileDownloadDirective extends HiddenFormPost {
	// eslint-disable-next-line
	@Input('cmFileDownload') path: string;
	@Input() targetWindow: '_blank' | '_self' | '_parent' | '_top' = '_self';

	constructor(el: ElementRef, auth: CmAuthService, renderer: Renderer2) {
		super(el, auth, renderer);
	}
}
